import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import GenericList from "./GenericList";
import ButtonComponent from "./ButtonComponent";
import { COLORS } from "../config/theme";
import { obtenerHistorialRequisito } from "../services/historial.service";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import Loader from "../components/Loader";
import { obtenerDocumento } from "../services/uploadFile.service";
import moment from "moment-timezone";

export default function RequisitoListaHistorico({
  setIsVisibleModal,
  setReload,
  reload,
  requisito,
}) {
  const [dataHistorica, setDataHistorica] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1); // Corrected state name
  const [currentPageSize, setCurrentPageSize] = useState(10); // Corrected state name
  const [orderByField, setOrderByField] = useState(
    "expediente_req_historico.fecha_modificacion"
  );
  const [orderByDirection, setOrderByDirection] = useState("desc");
  const [localReload, setLocalReload] = useState(false);

  const abrirDocumento = async (key) => {
    try {
      const response = await obtenerDocumento(key);

      if (response) {
        const signedUrl = response.url;
        const resultURL = signedUrl.split("?");

        window.open(resultURL[0], "_blank");
      } else {
        console.error("Error obteniendo documento");
        // TODO: Mostrar mensaje en pantalla
      }
    } catch (error) {
      console.error("Failed to get signed URL", error);
    }
  };

  const columnas = [
    { title: "ACCIÓN", field: "motivo", width: "50px" },
    {
      title: "FECHA",
      field: "fecha_modificacion",
      width: "50px",
      render: (row) =>
        row.mov_respuesta_fecha
          ? moment(row.fecha_modificacion).utcOffset(-180).format("DD/MM/YYYY HH:mm") // UTC -3
          : "--/--/----",
    },
    { title: "PROFESIONAL", field: "mov_respuesta_usu_nombre", width: "30px" },
    // { title: "RESPUESTA", field: "mov_respuesta_obs", width: '200px' },
    {
      title: "RESPUESTA",
      field: "mov_respuesta_file_url",
      render: (row) =>
        row.respuesta_file_url ? (
          <div
            onClick={() => abrirDocumento(row.respuesta_file_url)}
            style={{
              textDecoration: "none",
              color: "inherit",
              cursor: "pointer",
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <DescriptionOutlinedIcon style={{ fontSize: 30 }} />
            <Typography variant="body2">{row.respuesta_file_nombre}</Typography>
          </div>
        ) : (
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {row.mov_respuesta_obs}
          </div>
        ),
      width: "40px",
    },
    { title: "REVISOR", field: "mov_revision_us_nombre", width: "30px" },
    { title: "MOTIVO RECHAZO", field: "mov_revision_obs", width: "30px" },
    {
      title: "ARCHIVO RECHAZO",
      field: "revision_file_url",
      render: (row) =>
        row.revision_file_url && (
          <div
            onClick={() => abrirDocumento(row.revision_file_url)}
            style={{
              textDecoration: "none",
              color: "inherit",
              cursor: "pointer",
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <DescriptionOutlinedIcon style={{ fontSize: 30 }} />
            <Typography variant="body2">{row.revision_file_nombre}</Typography>
          </div>
        ),
      width: "60px",
    },
  ];

  const obtenerHistorial = async () => {
    setIsLoading(true);
    const historialRequisito = await obtenerHistorialRequisito(
      requisito.id_mov,
      currentPageSize,
      currentPage,
      orderByField,
      orderByDirection
    );
    setDataHistorica(historialRequisito.data);
    setIsLoading(false);
  };

  const onClose = () => {
    setIsVisibleModal(false);
  };

  useEffect(() => {
    obtenerHistorial();
  }, [requisito, localReload]);

  useEffect(() => {
    const errorHandler = (e) => {
      if (
        e.message.includes(
          "ResizeObserver loop completed with undelivered notifications" ||
            "ResizeObserver loop limit exceeded"
        )
      ) {
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.style.display = "none";
        }
      }
    };
    window.addEventListener("error", errorHandler);
    return () => {
      window.removeEventListener("error", errorHandler);
    };
  });

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Grid item xs={12}>
            <GenericList
              columns={columnas}
              data={dataHistorica}
              actions={[]}
              itemsToShow={5}
              hideSearch={true}
              hideFilter={true}
              addDisabled={true}
              onPageChange={(page) => {
                console.log("Current page", page + 1);
                setCurrentPage(page + 1);
              }}
              onPageSizeChange={(pageSize) => {
                console.log("Page size", pageSize);
                setCurrentPageSize(pageSize);
              }}
              onOrderChange={(order) => {
                console.log("New order", order[0]);
                setOrderByField(order[0]?.orderByField);
                setOrderByDirection(order[0]?.orderDirection);
                setLocalReload(!localReload);
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end">
              <ButtonComponent
                name="Cerrar"
                toAction={onClose}
                color={COLORS.DANGER}
              />
            </Box>
          </Grid>
        </>
      )}
    </>
  );
}
